import React from "react";
import { useTranslation } from "react-i18next";
import { Typography, Grid, InputAdornment } from "@mui/material";
import { MailTemplateTextField } from "./mailTemplateTextField";
import { MailTemplateVisualEditorOptionsSection } from "./mailTemplateVisualEditorOptionsSection";
export type MailTemplateVisualEditorPaddingOptions = {
    top: number,
    bottom: number,
    left: number
    right: number
}

type Props = {
    title?: string,
    padding: MailTemplateVisualEditorPaddingOptions,
    onChangePadding: (
        type: keyof MailTemplateVisualEditorPaddingOptions,
        value: number
    ) => void
}

export function MailTemplateVisualEditorPaddingOptions(props: Props): JSX.Element {
    const {t} = useTranslation();
    return (
        <MailTemplateVisualEditorOptionsSection>
            <Typography>
                {
                    props.title ?? t('shared.mail-template-visual-editor-padding')
                }
            </Typography>
            <Grid container spacing={1}>
                <Grid item xs={3}>
                    <MailTemplateTextField
                        type="number"
                        variant="outlined"
                        label={t('shared.mail-template-visual-editor-top')}
                        InputProps={{
                            endAdornment: <InputAdornment position="end">px</InputAdornment>,
                        }}
                        value={props.padding.top}
                        onChange={(event) => {
                            props.onChangePadding('top', parseInt(event.target.value));
                        }}
                    />
                </Grid>
                <Grid item xs={3}>
                    <MailTemplateTextField
                        type="number"
                        variant="outlined"
                        label={t('shared.mail-template-visual-editor-bottom')}
                        InputProps={{
                            endAdornment: <InputAdornment position="end">px</InputAdornment>,
                        }}
                        value={props.padding.bottom}
                        onChange={(event) => {
                            props.onChangePadding('bottom', parseInt(event.target.value));
                        }}
                    />
                </Grid>
                <Grid item xs={3}>
                    <MailTemplateTextField
                        type="number"
                        variant="outlined"
                        label={t('shared.mail-template-visual-editor-left')}
                        InputProps={{
                            endAdornment: <InputAdornment position="end">px</InputAdornment>,
                        }}
                        value={props.padding.left}
                        onChange={(event) => {
                            props.onChangePadding('left', parseInt(event.target.value));
                        }}
                    />
                </Grid>
                <Grid item xs={3}>
                    <MailTemplateTextField
                        type="number"
                        variant="outlined"
                        label={t('shared.mail-template-visual-editor-right')}
                        InputProps={{
                            endAdornment: <InputAdornment position="end">px</InputAdornment>,
                        }}
                        value={props.padding.right}
                        onChange={(event) => {
                            props.onChangePadding('right', parseInt(event.target.value));
                        }}
                    />
                </Grid>
            </Grid>
        </MailTemplateVisualEditorOptionsSection>
    );
}